import type { ComponentProps } from 'react';

import { clsx } from 'clsx';
import { Button } from 'design-system';

const selectorButtonClassName =
  'mr-2 h-6 rounded-none bg-gx-text/20 px-2 text-[0.7rem] shadow-none outline-none hover:bg-gx-text/40 hover:shadow-none';

export const SelectorButton = ({ className, ...props }: ComponentProps<typeof Button>) => (
  <Button
    className={clsx(selectorButtonClassName, className)}
    size='xs'
    {...props}
  />
);
